import React from 'react';
import { useHistory, Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Box from 'ui-box';
import { Row, Col, Typography, Button } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ReactComponent as TogetherSvg } from '../../../assets/icons/together.svg';
import LoginForm from '../../../components/mobile/LoginForm';
import MobileHeader from '../../../components/mobile/Header';

const { Title } = Typography;

const styles = {
  title: {
    margin: '35px 0px',
    whiteSpace: 'pre-line',
    fontSize: '20px',
    color: '#15A9E1',
    fontWeight: '400'
  },
  welcomeTitle: {
    margin: '15px 0 25px',
    whiteSpace: 'pre-line',
  },
};

function MobileLogin() {
  const { t } = useTranslation(['common', 'welcome']);
  const history = useHistory();

  const onBack = () => {
    history.push('/sign-in-select');
  }

  return (
    <>
      <MobileHeader />
      <Box paddingTop={30} paddingBottom={12} paddingX={20}>
        <Row justify="center" style={{ padding: 0, marginBottom: 25 }}>
          <Col>
            <Button type="link" onClick={onBack}>
              <p style={styles.rowButton}>
                <ArrowLeftOutlined style={{ color: '#15A9E1', marginRight: 10 }} /> {t('welcome:login.previous')}
              </p>
            </Button>
          </Col>
        </Row>
        <Box display="flex" justifyContent="center">
          <TogetherSvg style={{ margin: '20', maxWidth: '80%' }} />
        </Box>
        <Box textAlign="center">
          <Row gutter={[0, 24]}>
            <Col xs={24}>
              <Title level={4} style={styles.title}>
                {t('welcome:login.title')}
              </Title>
              <LoginForm onSubmitBtnText={t('common:button.login')} />
              <div style={{ textAlign: 'center', padding: 15 }}>
                <Link to="/forgot-password">{t('common:forgotPasswordText')}</Link>
              </div>
            </Col>
          </Row>
        </Box>
      </Box>
    </>
  );
}

export default MobileLogin;
